<template>
  <div>
    <PageAllow controller="FinanceBills" action="index" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4" v-if="financeBillType == 101">
            <v-row dense align="center" class="pa-1">
              <SearcherDatetimeRangeWithRadio
                v-model="options"
                type="datetime"
                :radios="datetimeRadios"
                removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="4" v-if="financeBillType == 201">
            <v-row dense align="center" class="pa-1">
              <SearcherDatetimeRangeWithRadio
                v-model="options"
                type="datetime"
                :radios="orderDatetimeRadios"
                removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <!-- 批量导出 -->
              <v-btn
                small
                color="print"
                dark
                class="ms-1"
                @click.stop="exportExcel()"
              >
                <v-icon x-small class="pe-1">fa-file-excel</v-icon>
                {{ $t("financeBills.export") }}
              </v-btn>
              <!-- 批量修改 -->
              <v-btn
                v-if="financeBillType == 101"
                small
                color="primary"
                dark
                class="ms-1"
                @click.stop="batchEdit()"
              >
                {{ $t("financeBills.batch_edit") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>

        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="finance_bill_code"
                    v-model="options.finance_bill_code"
                    @text="financeBillCodeKyeWord = $event"
                    :label="$t('financeBills.Fields.finance_bill_code')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-autocomplete
                    v-model="financeBillType"
                    :items="$consts.financeBillType"
                    :label="$t('financeBills.billTypes.title')"
                  >
                  </v-autocomplete>
                </v-col>
                <!-- 对象 -->
                <v-col cols="12" sm="6" md="4" v-if="financeBillType == 101">
                  <SearcherShops
                    v-model="shopsSelected"
                    :label="$t('financeBills.Fields.name')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4" v-else>
                  <SearcherSuppliers
                    v-model="supplierSelected"
                    :label="$t('financeBills.Fields.name')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="bill_code"
                    v-model="options.bill_code"
                    @text="billCodeKyeWord = $event"
                    :label="$t('financeBills.Fields.bill_code')"
                  />
                </v-col>
                <!-- 要货单号 -->
                <v-col cols="12" sm="6" md="4" v-if="financeBillType == 101">
                  <SearcherKeyword
                    ref="order_code"
                    v-model="options.order_code"
                    @text="orderCodeKyeWord = $event"
                    :label="$t('financeBills.Fields.order_code')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4" v-else>
                  <SearcherKeyword
                    ref="org_code"
                    v-model="options.org_code"
                    @text="orgCodeKyeWord = $event"
                    :label="$t('financeBills.Fields.org_code')"
                  />
                </v-col>
                <!-- 组别 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherDistrictsWithDescendants v-model="DistrictsSelected" />
                </v-col>
                <!-- 财务状态 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    :label="$t('financeBills.payFlgs.title')"
                    :items="$consts.financeFlgs"
                    v-model="options.pay_flgs"
                  />
                </v-col>
                <!-- 对账状态 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    :label="$t('financeBills.billCheckFlg.title')"
                    :items="$consts.billCheckFlg"
                    v-model="options.bill_check_flgs"
                  />
                </v-col>
                <!-- 归账状态 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    :label="$t('financeBills.billStatus.title')"
                    :items="$consts.billFlgs"
                    v-model="options.bill_status"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <div class="mx-4 mb-4">
          <v-data-table
            v-model="showSelected"
            :headers="headers"
            :items="finance_bills"
            :options.sync="options"
            :loading="loading"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            show-select
            class="elevation-1 px-4 pt-1"
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:header.order_code="{ header }">
              <span v-if="financeBillType == 101">
                {{ header.text }}
              </span>
              <span v-else>
                {{ $t("financeBills.Fields.org_code") }}
              </span>
            </template>
            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>

            <template v-slot:item.order_code="{ item }">
              <span v-if="financeBillType == 101">
                {{ item.order_code }}
              </span>
              <span v-else>
                {{ item.bill.org_code }}
              </span>
            </template>
            <template v-slot:item.shop_name="{ item }">
              <span class="text-no-wrap caption font-weight-bold">
                {{
                  item.shop ? item.shop.shop_name : item.supplier.supplier_name
                }}
              </span>
              <br />
              <span
                class="text-no-wrap caption secondary--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
                {{
                  item.shop ? item.shop.shop_code : item.supplier.supplier_code
                }}
              </span>
            </template>

            <template v-slot:item.fee="{ item }">
              {{ $t("Global.money") }}
              {{ item.fee | formatMoney }}
            </template>

            <template v-slot:item.bill_check_flg="{ item }">
              <v-chip
                small
                label
                :color="item.bill.bill_check_flg | billCheckFlgColor"
                :text-color="item.bill.bill_check_flg | billCheckFlgTextColor"
              >
                {{ item.bill.bill_check_flg | billCheckFlgText }}
              </v-chip>
            </template>

            <template v-slot:item.pay_flg="{ item }">
              <v-chip
                small
                label
                :color="item.bill.pay_flg | financeFlgsColor"
                :text-color="item.bill.pay_flg | financeFlgsTextColor"
              >
                {{ item.bill.pay_flg | financeFlgsText }}
              </v-chip>
            </template>
            <template v-slot:item.status="{ item }">
              <v-chip
                small
                label
                :color="item.bill.status | billFlgsColor"
                :text-color="item.bill.status | billFlgsTextColor"
              >
                {{ item.bill.status | billFlgsText }}
              </v-chip>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-tooltip
                top
                v-if="$permission.permissionAllow('FinanceBills', 'view')"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    dark
                    v-bind="attrs"
                    v-on="on"
                    color="info"
                    class="px-2 me-2 mb-1"
                    :href="'/#/finance-bills/' + item.id"
                  >
                    <v-icon x-small class="pe-1">fa-align-left</v-icon>
                    {{ $t("financeBills.details") }}
                  </v-btn>
                </template>
                <span>{{ $t("financeBills.details") }}</span>
              </v-tooltip>

              <!-- Edit -->
              <v-tooltip
                top
                v-if="
                  $permission.permissionAllow('FinanceBills', 'edit') &&
                  item.bill.status == 1
                "
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    dark
                    v-bind="attrs"
                    v-on="on"
                    color="action"
                    class="px-2 me-2 mb-1"
                    :href="
                      '/#/finance-bills/edit/' +
                      item.id +
                      '?financeBillCode=' +
                      item.finance_bill_code
                    "
                  >
                    <!-- <v-icon x-small class="pe-1">fa-align-left</v-icon> -->
                    {{ $t("financeBills.edit") }}
                  </v-btn>
                </template>
                <span>{{ $t("financeBills.edit") }}</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import SearcherDistrictsWithDescendants from "@/components/plugins/SearcherDistrictsWithDescendants";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import FinanceBills from "@/api/finance_bills";
import SearcherShops from "@/components/plugins/SearcherShops";
import SearcherSuppliers from "@/components/plugins/SearcherSuppliers";

const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  org_time_from: "",
  org_time_to: "",
  district_ids: [],
  pay_flgs: [1, 2, 3],
  bill_check_flgs: [0, 1],
  bill_status: [0, 1],
  finance_bill_code: "",
  bill_code: "",
  finance_bill_type: 101,
  order_code: "",
  org_code: "",
  shop_ids: [],
  supplier_ids: [],
};

export default {
  data: () => ({
    options: JSON.parse(
      sessionStorage.getItem("finance_bills-options")
        ? sessionStorage.getItem("finance_bills-options")
        : JSON.stringify(defaultOptions)
    ),
    DistrictsSelected: [],
    paging: {},
    finance_bills: [],
    showSelected: [],
    financeBillType: 101,
    shopsSelected: [],
    supplierSelected: [],
  }),

  components: {
    SearcherStatus,
    SearcherDatetimeRangeWithRadio,
    SearcherDistrictsWithDescendants,
    PageAllow,
    Breadcrumbs,
    SearcherKeyword,
    SearcherShops,
    SearcherSuppliers,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.fundManagement"),
        disabled: false,
        href: "/receipts",
      },
      {
        text: i18n.t("Nav.inanceReceipt"),
        disabled: true,
        href: "/finance-receipt",
      },
    ],
    datetimeRadios: () => [
      {
        key: "created",
        text: i18n.t("financeBills.time"),
      },
    ],
    orderDatetimeRadios: () => [
      {
        key: "org",
        text: i18n.t("financeBills.org_time"),
      },
    ],
    headers() {
      return [
        {
          text: i18n.t("financeBills.Fields.finance_bill_code"),
          align: "start",
          sortable: false,
          value: "finance_bill_code",
        },
        {
          text: i18n.t("financeBills.Fields.bill_code"),
          align: "start",
          sortable: false,
          value: "bill.bill_code",
        },
        {
          text: i18n.t("financeBills.Fields.order_code"),
          align: "start",
          sortable: false,
          value: "order_code",
        },
        {
          text: i18n.t("financeBills.Fields.name"),
          align: "start",
          sortable: false,
          value: "shop_name",
        },
        {
          text: i18n.t("financeBills.Fields.fee"),
          align: "end",
          sortable: false,
          value: "fee",
        },
        {
          text: i18n.t("financeBills.Fields.billCheckFlg"),
          align: "start",
          sortable: false,
          value: "bill_check_flg",
        },
        {
          text: i18n.t("financeBills.Fields.payFlgs"),
          align: "start",
          sortable: false,
          value: "pay_flg",
        },
        {
          text: i18n.t("financeBills.Fields.billStatus"),
          align: "start",
          sortable: false,
          value: "status",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        },
      ];
    },
    ...mapState(["loading"]),
  },

  mounted() {
    this.$commonUtils
      .loadOptions("finance_bills", [
        "DistrictsSelected",
        "shopsSelected",
        "supplierSelected",
      ])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
          } else this.resetSearch();

          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "DistrictsSelected":
                this.DistrictsSelected = selected.value;
                break;
              case "shopsSelected":
                this.shopsSelected = selected.value;
                break;
              case "supplierSelected":
                this.supplierSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },

  methods: {
    onSearch() {
      this.options = Object.assign(this.options, {
        finance_bill_code: this.financeBillCodeKyeWord,
        bill_code: this.billCodeKyeWord,
        order_code: this.orderCodeKyeWord,
        org_code: this.orgCodeKyeWord,
        finance_bill_type: this.financeBillType,
      });
      this.getFinanceBillsFromAPI();
    },
    resetSearch() {
      this.DistrictsSelected = [];
      this.financeBillType = 101;
      this.shopsSelected = [];
      this.supplierSelected = [];
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },
    getFinanceBillsFromAPI() {
      FinanceBills.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.finance_bills = response.data.finance_bills;
            this.paging = response.data.paging;
          }
        }.bind(this)
      );
    },
    batchEdit() {
      if (this.showSelected.length) {
        var showSelectedIds = [];
        this.showSelected.map((e) => {
          showSelectedIds.push(e.id);
        });
        this.$router.push({
          path: "/finance-bills/batch-edit",
          query: {
            financeBillIds: encodeURI(showSelectedIds),
          },
        });
      }
    },
    exportExcel() {
      FinanceBills.exportExcel(Object.assign({}, this.options));
    },
  },

  watch: {
    options: {
      deep: true,
      handler() {
        if (this.financeBillType == 101) {
          this.options.org_code = null;
        } else if (this.financeBillType == 201) {
          this.options.order_code = null;
        }
        this.financeBillType = this.options.finance_bill_type;
        this.getFinanceBillsFromAPI();
        sessionStorage.setItem(
          "finance_bills-options",
          JSON.stringify(this.options)
        );
      },
    },
    shopsSelected: {
      handler() {
        this.options.shop_ids =
          this.shopsSelected && this.shopsSelected.length
            ? this.shopsSelected.map((e) => {
                return e.id;
              })
            : [];
        sessionStorage.setItem(
          "finance_bills-shopsSelected",
          JSON.stringify(this.shopsSelected)
        );
      },
    },
    supplierSelected: {
      handler() {
        this.options.supplier_ids =
          this.supplierSelected && this.supplierSelected.length
            ? this.supplierSelected.map((e) => {
                return e.id;
              })
            : [];
        sessionStorage.setItem(
          "finance_bills-supplierSelected",
          JSON.stringify(this.supplierSelected)
        );
      },
    },
    // 组别
    DistrictsSelected: {
      handler() {
        this.options.district_ids = this.DistrictsSelected
          ? this.DistrictsSelected.map((e) => {
              return e.id;
            })
          : "";
        sessionStorage.setItem(
          "finance_bills-DistrictsSelected",
          JSON.stringify(this.DistrictsSelected)
        );
      },
    },
    // 已选择 的 id  [  ]
    showSelected: {
      handler() {
        var showSelectedId = [];
        this.showSelected.map((e) => {
          showSelectedId.push(e.id);
        });
      },
    },
    financeBillType: {
      handler() {
        this.options.finance_bill_type = this.financeBillType;
        if (this.financeBillType == 101) {
          this.options.datetimeRadioSelected = "created";
          this.options.created_time_from = this.options.created_time_from
            ? this.options.created_time_from
            : this.options.org_time_from;
          this.options.created_time_to = this.options.created_time_to
            ? this.options.created_time_to
            : this.options.org_time_to;
          this.options.org_time_from = "";
          this.options.org_time_to = "";
          this.supplierSelected = [];
        } else if (this.financeBillType == 201) {
          this.options.datetimeRadioSelected = "org";
          this.options.org_time_from = this.options.org_time_from
            ? this.options.org_time_from
            : this.options.created_time_from;
          this.options.org_time_to = this.options.org_time_to
            ? this.options.org_time_to
            : this.options.created_time_to;
          this.options.created_time_from = "";
          this.options.created_time_to = "";
          this.shopsSelected = [];
        }
      },
    },
  },
};
</script>

<style>
</style>